export const styles = {
  listItemButton: {
    "& .MuiSvgIcon-root": {
      fontSize: 30,
      ml: -0.5,
      my: -0.25,
    },
  },
};
